var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loader"},[_c('img',{staticClass:"loader-img",class:{  'sm': _vm.size ===  'sm'  },attrs:{"src":require("@/assets/images/icons/loader-points.gif")}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }